import { keywords } from "@/mocks/kanliao";

const sizeClass = (w: number) => {
  if (w === 5) return "px-5 py-2 text-base md:text-lg";
  if (w === 4) return "px-4 py-1.5 text-sm md:text-[15px]";
  if (w === 3) return "px-3.5 py-1.5 text-[13px]";
  return "px-3 py-1 text-xs";
};

export default function WordCloud() {
  return (
    <section id="words" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <span className="font-label text-xs font-semibold uppercase tracking-[0.24em] text-primary-600">
              吃瓜热词风向
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              本周瓜田，大家都在搜什么
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-secondary-700">
            从热搜词条里抓取的上升关键词，字号越大热度越高。看料网帮你快速锚定最近的核心吃瓜方向。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-3 gap-y-3 rounded-2xl bg-background-100 px-6 py-8 md:gap-x-4 md:py-10">
          {keywords.map((k) => (
            <a
              href="#feed"
              key={k.name}
              className={`flex items-center whitespace-nowrap rounded-full font-semibold transition-all hover:-translate-y-0.5 ${
                k.hot
                  ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                  : k.weight >= 4
                    ? "bg-accent-500 text-foreground-950 hover:bg-accent-600"
                    : "bg-background-50 text-foreground-800 ring-1 ring-background-300 hover:ring-primary-300"
              } ${sizeClass(k.weight)}`}
            >
              {k.hot && <i className="ri-fire-fill mr-1 text-xs" aria-hidden="true"></i>}
              {k.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}